import { useCallback, useEffect, useRef, useState } from "react";

/**
 * 倒计时定时器hooks
 * 用于表格等场景的全局统一倒计时，每秒触发一次更新
 * restTimeKey  - 用于触发更新的时间戳key
 */
export const useCountdownTimer = () => {
    // 使用 ref 保存定时器句柄，避免每次渲染都重新创建定时器。
    const timer = useRef<number | null>(null);

    // 用于触发更新的时间戳key（每次更新时改变）
    const [restTimeKey, setRestTimeKey] = useState<number>(Date.now());

    /**
     * 启动定时器
     * 每秒更新一次restTimeKey，触发依赖组件重新渲染
     */
    const startTimer = () => {
        // 防止重复创建定时器
        if (timer.current !== null) return;

        timer.current = window.setInterval(() => {
            setRestTimeKey(Date.now());
        }, 1000);
    };

    /**
     * 清除定时器
     */
    const clearTimer = () => {
        if (timer.current !== null) {
            window.clearInterval(timer.current);
            timer.current = null;
        }
    };

    const startTimerCallback = useCallback(startTimer, []);
    const clearTimerCallback = useCallback(clearTimer, []);

    // 组件挂载时启动定时器，卸载时清理，避免 React 页面泄漏后台任务。
    useEffect(() => {
        startTimerCallback();
        return clearTimerCallback;
    }, [startTimerCallback, clearTimerCallback]);

    return {
        restTimeKey
    };
};
